export enum C4AParamsAttr {
  checkboxAutomaticTraining = 'checkboxAutomaticTraining',
  checkboxLB = 'checkboxLB',
  checkboxTimespan = 'checkboxTimespan',
  endDate = 'endDate',
  dopUploadID = 'dopUploadID',
  alkisUploadID = 'alkisUploadID',
  ndomUploadID = 'ndomUploadID',
  landcoverUploadID = 'landcoverUploadID',
  jobName = 'jobName',
  matrix = 'matrix',
  startDate = 'startDate',
  trainingDataUploadID = 'trainingDataUploadID',
  validationDataUploadID = 'validationDataUploadID',
  validationDate = 'validationDate',
  cdFilterUploadID = 'cdFilterUploadID',
  cdMaskUploadID = 'cdMaskUploadID'
}

export class C4AParams {

  checkboxAutomaticTraining: boolean;
  checkboxLB: boolean;
  checkboxTimespan: boolean;
  endDate: any;
  dopUploadID: string;
  alkisUploadID: string;
  ndomUploadID: string;
  landcoverUploadID: string;
  jobName: string;
  matrix: any;
  startDate: any;
  trainingDataUploadID: string;
  validationDataUploadID: string;
  validationDate: number;
  cdFilterUploadID: string;
  cdMaskUploadID: string;

  constructor() {
    this.checkboxAutomaticTraining = true;
    this.checkboxLB = false;
    this.checkboxTimespan = false;
    this.endDate = null;
    this.dopUploadID = '';
    this.alkisUploadID = '';
    this.ndomUploadID = '';
    this.landcoverUploadID = '';
    this.jobName = '';
    this.matrix = null;
    this.startDate = null;
    this.trainingDataUploadID = '';
    this.validationDataUploadID = '';
    this.cdFilterUploadID = '';
    this.cdMaskUploadID = '';
    this.validationDate = 0;
  }

  setCheckboxAutomaticTraining(value: boolean) {
    this.checkboxAutomaticTraining = value;
  }

  setCheckboxLB(value: boolean) {
    this.checkboxLB = value;
  }

  setCheckboxTimespan(value: boolean) {
    this.checkboxTimespan = value;
  }

  setEndDate(value: any) {
    this.endDate = value;
  }

  setDopUploadID(value: string) {
    this.dopUploadID = value;
  }

  setAlkisUploadID(value: string) {
    this.alkisUploadID = value;
  }

  setNdomUploadID(value: string) {
    this.ndomUploadID = value;
  }

  setLandcoverUploadID(value: string) {
    this.landcoverUploadID = value;
  }

  setJobName(value: string) {
    this.jobName = value;
  }

  setMatrix(value: any) {
    this.matrix = value;
  }

  setStartDate(value: any) {
    this.startDate = value;
  }

  setTrainingDataUploadID(value: string) {
    this.trainingDataUploadID = value;
  }

  setValidationDataUploadID(value: string) {
    this.validationDataUploadID = value;
  }

  setValidationDate(value: number) {
    this.validationDate = value;
  }

  setCdFilterUploadID(value: string) {
    this.cdFilterUploadID = value;
  }

  setCdMaskUploadID(value: string) {
    this.cdMaskUploadID = value;
  }
}
